import React from 'react'
import { connect } from 'react-redux'
import ConfirmableCheckboxView from '../component/ConfirmableCheckboxView'
import { Checkbox } from '../../Form/Checkbox'
import { showReduxModal } from '../../../Reducers/UI/actions'

const ConfirmableCheckbox = ({
  label,
  note,
  value,
  confirmationModal,
  showReduxModal,
  disabled,
}) => {
  const onChange = () => {
    if (disabled) return
    if (!confirmationModal.showOnDisable && value) {
      return confirmationModal.onConfirm(!value)
    }
    return showReduxModal({
      ...confirmationModal,
      onConfirm: () => confirmationModal.onConfirm(!value),
      children: confirmationModal.body,
    })
  }

  return (
    <ConfirmableCheckboxView note={note}>
      <Checkbox
        label={label}
        input={{
          value,
          onChange,
          disabled,
        }}
      />
    </ConfirmableCheckboxView>
  )
}

const mapDispatchToProps = {
  showReduxModal,
}

export default connect(
  null,
  mapDispatchToProps,
)(ConfirmableCheckbox)



// WEBPACK FOOTER //
// ./src/Components/ConfirmableCheckbox/container/ConfirmableCheckbox.js